var ResetPassword = {
	// properties
	obj_form: $('#form_reset'),

	// methods
	initPost: function() {
		console.debug('called', arguments.callee.name);

		this.setKeyPress('reset_password');

		return this;
	},
	setEventHandlers: function() {
		console.debug('called', arguments.callee.name);

		$('#btn_submit').on('click', (e) => {
			e.preventDefault();

			this.submitResetPassword();
		});

		return this;
	},
	submitResetPassword: function() {
		console.debug('called', arguments.callee.name);

		$.ajax({
			beforeSend: (xhr) => {
				xhr.setRequestHeader('X-WP-Nonce', window.rest_object.nonce);

				this.setCursorWait();
			},
			cache: false,
			data: this.obj_form.serializeArray(),
			dataType: 'json',
			processData: true,
			type: 'POST',
			url: window.rest_object.url + 'reset-password'
		})
			.done((response) => {
				this.clearErrors();

				if (typeof response.errors === 'object') {
					this.addErrors(response.errors);
				}

				const message = typeof response.message === 'string' ? response.message : null;
				const status = typeof response?.status === 'string' ? response.status : null;

				switch (status) {
					case 'success':
						this.obj_form.hide();

						$('#div_login').show();
						break;

					default:

				}

				this.clearCursorWait();

				this.writeMessage({
					message: message,
					status: status
				});
			})
			.fail((xhr, status, text) => {
				console.log({ xhr, status, text });

				if (typeof xhr.responseJSON === 'object') {
					const response = xhr.responseJSON;
					// console.log(response);

					this.clearErrors();

					if (typeof response.errors === 'object') {
						this.addErrors(response.errors);
					}

					if (typeof response.message === 'string' && typeof response.status === 'string') {
						this.writeMessage({
							message: response.message,
							status: response.status
						});
					}

					this.clearCursorWait();
				} else {
					this.writeMessage({
						message: 'Response error. Please speak to an administrator.',
						status: 'error'
					});
				}
			})
			.always(() => { });

		return this;
	}
};

$(function() {
	$.extend(true, Base, ResetPassword);

	const reset_password = $.extend(true, {}, Base);
	reset_password.init();
});
